import { render, staticRenderFns } from "./RadarDescription.vue?vue&type=template&id=2b2d0e12"
import script from "./RadarDescription.vue?vue&type=script&lang=js"
export * from "./RadarDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports